import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, Button, Select, IconButton, Tooltip } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useSwipeable } from 'react-swipeable';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedDate, setSelectedTimeSlot, setAvailability, resetForm } from '../reducers/bookingFormSlice';
import { fetchAvailabilityApi } from '../api/api';
import { useTranslation } from 'react-i18next';
import Utils from '../services/Utils';
import { setDateAndTimeSlot } from '../reducers/KiidoBookingSlice';

const DateSelector = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { selectedDate, selectedTimeSlot, availability } = useSelector((state) => state.bookingForm);
  const { selectedLocationId, selectedServiceId } = useSelector((state) => state.location);
  const { sessionsTypeStored } = useSelector((state) => state.sessionType);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [localdate, setLocaldate] = useState();





  useEffect(() => {
    if (sessionsTypeStored) {
      console.log("form resetted",)
      dispatch(resetForm());
    }

    // Get the current URL
    const urlParams = new URLSearchParams(window.location.search);

    // Get the 'specialist' parameter from the URL
    const specialist = urlParams.get('specialist');
    const thespecialist = specialist ? specialist.toLowerCase() : ''
    


    const fetchAvailability = async (fromDate, toDate) => {
      // console.log("fetchAvailability", selectedLocationId, sessionsTypeStored)
      try {
        const data = await fetchAvailabilityApi(fromDate, toDate, selectedLocationId, selectedServiceId, sessionsTypeStored, thespecialist);
        dispatch(setAvailability(data));
      } catch (error) {
        console.error('Error fetching availability:', error);
      }
    };

    const currentMonth = selectedMonth.getMonth();
    const currentYear = selectedMonth.getFullYear();

    const fromDate = new Date(Date.UTC(currentYear, currentMonth, 1)).toISOString().split('T')[0];
    
    // Calculate toDate as fromDate + 6 months
    const toDateObj = new Date(Date.UTC(currentYear, currentMonth, 1));
    toDateObj.setMonth(toDateObj.getMonth() + 6);
    toDateObj.setDate(0); // Last day of the previous month
    const toDate = toDateObj.toISOString().split('T')[0];

    fetchAvailability(fromDate, toDate);
  }, [dispatch, selectedMonth, selectedLocationId, selectedServiceId, sessionsTypeStored]);

  const handleMonthChange = (event) => {
    const [year, month] = event.target.value.split('-');
    setSelectedMonth(new Date(year, month - 1));
  };

  const getFilteredDates = () => {
    const startOfMonth = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1);
    const endOfMonth = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 0);
    const today = new Date();

    const startDate = (selectedMonth.getFullYear() === today.getFullYear() && selectedMonth.getMonth() === today.getMonth())
      ? today
      : startOfMonth;

    return Object.keys(availability).filter(date => {
      const currentDate = new Date(date);
      return currentDate >= startDate && currentDate <= endOfMonth.setHours(23, 59, 59, 999);
    });
  };

  const dates = getFilteredDates();

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleSwipe('left'),
    onSwipedRight: () => handleSwipe('right'),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const handleSwipe = (direction) => {
    const container = document.getElementById('date-container');
    const scrollAmount = container.clientWidth / 2;
    if (direction === 'left') {
      container.scrollLeft += scrollAmount;
    } else {
      container.scrollLeft -= scrollAmount;
    }
  };

  const handleSelectTimeSlot = (time, duration, index, tentative_availability_slot, consultation_mode) => {
    if (selectedTimeSlot && selectedTimeSlot.time === time && selectedTimeSlot.duration === duration && selectedTimeSlot.index === index) {
      dispatch(setSelectedTimeSlot(null)); // Unset if already selected
    } else {
      // console.log("timeselected", selectedDate, time, duration, index, tentative_availability_slot, consultation_mode)
      dispatch(setSelectedTimeSlot({ time, duration, index, tentative_availability_slot }));
      const alldata = { time, duration, index, tentative_availability_slot, consultation_mode }
      dispatch(setDateAndTimeSlot({ selectedDate: selectedDate, selectedTimeSlot: alldata }));
    }
  };

  function parseDurationToMinutes(durationString) {
    const [hours, minutes, seconds] = durationString.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes + seconds / 60;
    return `${totalMinutes} min`;
  }

  const getTimeSlots = (date) => {
    const slots = availability[date] || [];
    return slots.map((slot, index) => ({
      time: slot.start_time.slice(0, 5),
      duration: parseDurationToMinutes(slot.duration),
      index,
      tentative_availability_slot: slot.id,
      consultation_mode: slot.consultation_mode
    }));
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const getMonthYearOptions = () => {
    const currentDate = new Date();
    const options = [];
    const locale = i18n.language === 'fr' ? 'fr-FR' : 'en-US';
    
    // Generate options for next 6 months
    for (let i = 0; i < 6; i++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() + i);
      options.push({
        value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`,
        label: capitalizeFirstLetter(date.toLocaleString(locale, { month: 'long', year: 'numeric' })),
      });
    }
    return options;
  };

  const locale = i18n.language === 'fr' ? 'fr-FR' : 'en-US';

  return (
    <Box>
      <Flex mb={4} flexWrap="wrap" alignItems="center">
        <Select
          value={`${selectedMonth.getFullYear()}-${String(selectedMonth.getMonth() + 1).padStart(2, '0')}`}
          onChange={handleMonthChange}
          mr={2}
          mb={2}
          flexBasis={{ base: '40%', md: '20%' }}
        >
          {getMonthYearOptions().map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
        {/* <Select placeholder="CET (+02:00)" mb={2} flexBasis={{ base: '50%', md: '15%' }}> */}
        {/* Add more time zones as needed */}
        {/* </Select>  */}
      </Flex>
      <Box position="relative" mb={4}>
        <Flex alignItems="center">
          <IconButton
            aria-label="Scroll left"
            icon={<ChevronLeftIcon />}
            fontSize={{ base: '2rem', md: '2rem' }}
            backgroundColor={'white'}
            border={0}
            flexShrink="0"
            width="5%"
            onClick={() => handleSwipe('right')}
          />
          <Box
            id="date-container"
            {...swipeHandlers}
            overflowX="auto"
            whiteSpace="nowrap"
            css={{
              '&::-webkit-scrollbar': {
                display: 'none',
              },
              '-ms-overflow-style': 'none',
              'scrollbar-width': 'none',
            }}
            flex="1"
          >
            <Flex>
              {dates.map((date, index) => (
                <Box
                  key={index}
                  p={2}
                  bg={selectedDate === date ? '#FF6666' : 'white'}
                  color={selectedDate === date ? 'white' : 'black'}
                  border="1px solid"
                  borderColor="gray.300"
                  borderRadius="md"
                  textAlign="center"
                  cursor={availability[date].length === 0 ? 'not-allowed' : 'pointer'}
                  onClick={() => {
                    if (availability[date].length > 0) {
                      dispatch(setSelectedDate(date));
                      dispatch(setSelectedTimeSlot(null)); // Unset the time slot when a new date is selected
                    }
                  }}
                  mx={1}
                  flexShrink="0"
                  width="85px"
                  opacity={availability[date].length === 0 ? 0.6 : 1} // Adjust opacity for disabled state
                >
                  <Text>{new Date(date).toLocaleDateString(locale, { weekday: 'short' })}</Text>
                  <Text fontSize="xl" fontWeight="bold">{new Date(date).getDate()}</Text>
                  <Text
                    fontSize="sm"
                    bg={selectedDate === date ? '#FF6666' : 'transparent'}
                    color={selectedDate === date ? 'white' : (availability[date].length === 0 ? 'gray.400' : '#CE2F2B')}
                    isTruncated
                  >
                    {availability[date].length === 0 ? t('content.no_slots') : `${availability[date].length} ${t('content.slots')}`}
                  </Text>
                </Box>
              ))}
            </Flex>
          </Box>
          <IconButton
            aria-label="Scroll right"
            icon={<ChevronRightIcon />}
            fontSize={{ base: '2rem', md: '2rem' }}
            backgroundColor={'white'}
            border={0}
            flexShrink="0"
            width="5%"
            onClick={() => handleSwipe('left')}
          />
        </Flex>
      </Box>
      <Flex flexWrap="wrap" justifyContent={{ base: 'center', md: 'flex-start' }} mb={4}>
        {selectedDate && availability[selectedDate] && availability[selectedDate].length > 0 ? (
          getTimeSlots(selectedDate).map((slot, index) => (
            <>
              {/* {console.log("getTimeSlots MAP data", slot)} */}
              <Button
                onClick={() => handleSelectTimeSlot(slot.time, slot.duration, index, slot.tentative_availability_slot, slot.consultation_mode)}
                bg={selectedTimeSlot && selectedTimeSlot.time === slot.time && selectedTimeSlot.duration === slot.duration && selectedTimeSlot.index === index ? '#FF6666' : 'white'}
                color={selectedTimeSlot && selectedTimeSlot.time === slot.time && selectedTimeSlot.duration === slot.duration && selectedTimeSlot.index === index ? 'white' : '#FF6666'}
                border="1px solid"
                borderColor="gray.300"
                borderRadius="md"
                _active={{ bg: '#FF6666', color: 'white' }}
                _focus={{ boxShadow: 'none', outline: 'none', bg: '#FF6666', color: 'white' }}
                _hover={{ backgroundColor: 'none' }}
                m={1}
                p={8}
                width={{ base: '100%', sm: 'auto' }}
                aria-label={`Select time slot for ${slot.time} - ${slot.duration}`} // Accessibility
              >
                <Flex direction="column">
                  <Text color={selectedTimeSlot && selectedTimeSlot.time === slot.time && selectedTimeSlot.duration === slot.duration && selectedTimeSlot.index === index ? 'white' : '#CE2F2B'}>
                    {Utils.convertUTCToLocalTimeZone(slot.time)} - {slot.duration}
                  </Text>
                  <Flex direction="row" align="baseline" justifyContent="space-around" pt={1}>
                    {slot.consultation_mode.map((mods, modIndex) => {
                      const isActive = selectedTimeSlot && selectedTimeSlot.time === slot.time && selectedTimeSlot.duration === slot.duration && selectedTimeSlot.index === index;

                      return (
                        <Tooltip
                          key={modIndex}
                          label={i18n.language === "en" ? mods?.name : mods?.name_fr} // Tooltip content based on language
                          hasArrow
                          placement="top" // Position of the tooltip
                        >
                          <img
                            src={mods?.image}
                            alt={mods?.name}
                            style={{
                              width: '18px'
                            }}
                          />
                        </Tooltip>
                      );
                    })}
                  </Flex>
                </Flex>
              </Button>
            </>
          ))
        ) : (
          <Text fontSize="lg" color="gray.500">{t('content.no_slots')}</Text>
        )}
      </Flex>
    </Box>
  );
};

export default DateSelector;
